var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16.199,
  height: 16.2,
  viewBox: "0 0 16.199 16.2"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_4057",
  "data-name": "Group 4057",
  transform: "translate(-402.647 -1320.664)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2193",
  "data-name": "Group 2193",
  transform: "translate(402.747 1330.929)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2192",
  "data-name": "Group 2192"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M32.45,307.2a.6.6,0,0,0-.615.584v3.5a.6.6,0,0,1-.615.583H18.912a.6.6,0,0,1-.615-.583v-3.5a.616.616,0,0,0-1.231,0v3.5a1.8,1.8,0,0,0,1.846,1.75H31.219a1.8,1.8,0,0,0,1.846-1.75v-3.5A.6.6,0,0,0,32.45,307.2Z",
  transform: "translate(-17.066 -307.2)",
  fill: "#1370fc",
  stroke: "#1370fb",
  strokeWidth: 0.2
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2195",
  "data-name": "Group 2195",
  transform: "translate(407.416 1320.764)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2194",
  "data-name": "Group 2194",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M143.232,8.141a.631.631,0,0,0-.773,0l-1.832,1.55V.471a.564.564,0,0,0-1.112,0v9.22l-1.831-1.55a.63.63,0,0,0-.786.012.421.421,0,0,0,0,.654l2.78,2.354a.63.63,0,0,0,.786,0h0l2.78-2.354A.422.422,0,0,0,143.232,8.141Z",
  transform: "translate(-136.742 0)",
  fill: "#1370fc",
  stroke: "#1370fb",
  strokeWidth: 0.2
}))))));
export default __webpack_public_path__ + "static/media/download.84292e5d.svg";
export { SvgComponent as ReactComponent };